<header class="page-header">
    <div class="di-heading-wrapper">
        <h1 class="page-title">{{title}}</h1>
    </div>
</header>